// import React, { useEffect, useState } from "react";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import { TextField } from "@mui/material";

// const tableColumns = [
//   {
//     field: "delivery_name",
//     headerName: "Delivery Partner Name",
//     width: 200,
//   },
//   {
//     field: "phone",
//     headerName: "Phone Number",
//     width: 150,
//   },
//   {
//     field: "balance",
//     headerName: "Balance",
//     width: 100,
//   },
//   {
//     field: "creditHistory",
//     headerName: "Credit History",
//     width: 250,
//     renderCell: (params) => {
//       const creditHistory = params.value || []; // Default to empty array if undefined
//       return (
//         <ul>
//           {creditHistory.map((history) => (
//             <li key={history._id}>
//               +₹{history.amount} on {new Date(history.date).toLocaleDateString()} ({history.status})
//             </li>
//           ))}
//         </ul>
//       );
//     },
//   },
//   {
//     field: "debitHistory",
//     headerName: "Debit History",
//     width: 250,
//     renderCell: (params) => {
//       const debitHistory = params.value || []; // Default to empty array if undefined
//       return (
//         <ul>
//           {debitHistory.map((history) => (
//             <li key={history._id}>
//               -₹{history.amount} on {new Date(history.date).toLocaleDateString()} ({history.status})
//             </li>
//           ))}
//         </ul>
//       );
//     },
//   },
//   {
//     field: "debitTotal",
//     headerName: "Debit Total",
//     width: 150,
//     renderCell: (params) => `₹${params.value}`, // Display total debit amount with currency symbol
//   },
//   {
//     field: "Action",
//     headerName: "Action",
//     width: 200,
//     renderCell: () => (
//       <div className="m flex items-center">
//         <button className="m-2 rounded-sm bg-green-400 p-2 font-normal text-white">
//           Accept
//         </button>
//         <button className="m-2 rounded-sm bg-red-400 p-2 font-normal text-white">
//           Hold
//         </button>
//       </div>
//     ),
//   },
// ];

// const DeliveryPayoutReq = () => {
//   const [searchText, setSearchText] = useState("");
//   const [tableData, setTableData] = useState([]);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const res = await axios.get("https://api.medstown.com/delivery/getreq/amount");
//       console.log(res.data); // Log the response data for debugging
//       // Ensure each item has separate fields for credit and debit history
//       const formattedData = res.data.map(item => {
//         const debitHistory = (item.walletHistory || []).filter(history => history.status === "debit");
//         const debitTotal = debitHistory.reduce((total, history) => total + history.amount, 0);
//         return {
//           ...item,
//           creditHistory: (item.walletHistory || []).filter(history => history.status === "credit"),
//           debitHistory,
//           debitTotal, // Add total debit amount to data
//         };
//       });
//       setTableData(formattedData);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleSearchTextChange = (event) => {
//     setSearchText(event.target.value);
//   };

//   const filteredRows = tableData.filter((row) =>
//     Object.values(row).some(
//       (value) =>
//         value &&
//         value.toString().toLowerCase().includes(searchText.toLowerCase())
//     )
//   );

//   return (
//     <div>
//       <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
//         <TextField
//           label="Search"
//           variant="outlined"
//           fullWidth
//           value={searchText}
//           onChange={handleSearchTextChange}
//         />
//         <DataGrid
//           rows={filteredRows}
//           columns={tableColumns}
//           pageSize={5}
//           rowsPerPageOptions={[5]}
//           disableSelectionOnClick
//           disableColumnSelector
//           disableColumnFilter
//           sx={{ width: "100%" }}
//           getRowId={(row) => row._id || row.phone || row.delivery_name || Math.random()} // Ensure unique IDs
//           components={{
//             Toolbar: GridToolbar,
//           }}
//         />
//       </div>
//     </div>
//   );
// };

// export default DeliveryPayoutReq;





import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import {
  TextField,
  Box,
  Typography,
  Card,
  Stack,
  Chip,
  Avatar,
  useTheme,
  alpha,
  LinearProgress,
  Skeleton,
  Alert,
  Container,
  InputAdornment,
  IconButton,
  Button,
  Paper,
  Collapse,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import {
  MdSearch,
  MdClear,
  MdLocalShipping,
  MdAccountBalanceWallet,
  MdTrendingUp,
  MdTrendingDown,
  MdPhone,
  MdPerson,
  MdCheck,
  MdPause,
  MdExpandMore,
  MdExpandLess,
  MdError,
  MdAttachMoney,
} from "react-icons/md";
import dayjs from "dayjs";

const DeliveryPayoutReq = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [searchText, setSearchText] = useState("");
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);

  // Medstown brand colors
  const medstownColors = {
    primary: "#014D4D",
    secondary: "#02A0A0",
    accent: "#FFB800",
    success: "#4caf50",
    error: "#f44336",
    warning: "#ff9800",
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axios.get(
        "https://api.medstown.com/delivery/getreq/amount"
      );

      const formattedData = res.data.map((item) => {
        const debitHistory = (item.walletHistory || []).filter(
          (history) => history.status === "debit"
        );
        const creditHistory = (item.walletHistory || []).filter(
          (history) => history.status === "credit"
        );
        const debitTotal = debitHistory.reduce(
          (total, history) => total + history.amount,
          0
        );
        const creditTotal = creditHistory.reduce(
          (total, history) => total + history.amount,
          0
        );

        return {
          ...item,
          creditHistory,
          debitHistory,
          debitTotal,
          creditTotal,
          id: item._id || item.phone || Math.random(),
        };
      });
      setTableData(formattedData);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch delivery partner data. Please try again.");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
    setSearchLoading(true);
    setTimeout(() => setSearchLoading(false), 300);
  };

  const clearSearch = () => {
    setSearchText("");
  };

  const toggleRowExpansion = (id) => {
    setExpandedRows((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleAction = async (partnerId, action) => {
    try {
      console.log(`${action} action for partner ${partnerId}`);
      // Add your API call here
    } catch (error) {
      console.error(`Error ${action}ing partner:`, error);
    }
  };

  const filteredRows = tableData.filter((row) =>
    Object.values(row).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );

  const HistoryList = ({ history, type }) => {
    const isCredit = type === "credit";

    return (
      <Box sx={{ 
        maxHeight: isMobile ? 80 : 120, 
        overflowY: "auto", 
        pr: 1, 
        mt: isMobile ? 1 : 3,
        minWidth: isMobile ? 120 : 150 // Ensure minimum width for horizontal scroll
      }}>
        <Stack spacing={0.5}>
          {history.length === 0 ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ fontSize: isMobile ? "0.6rem" : "0.65rem" }}
            >
              No {type} history
            </Typography>
          ) : (
            history.slice(0, isMobile ? 2 : 3).map((item, index) => (
              <Paper
                key={item._id || index}
                sx={{
                  p: isMobile ? 0.5 : 1,
                  backgroundColor: alpha(
                    isCredit ? medstownColors.success : medstownColors.error,
                    0.05
                  ),
                  border: `1px solid ${alpha(
                    isCredit ? medstownColors.success : medstownColors.error,
                    0.1
                  )}`,
                  borderRadius: 1,
                }}
              >
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  {isCredit ? (
                    <MdTrendingUp size={isMobile ? 8 : 10} color={medstownColors.success} />
                  ) : (
                    <MdTrendingDown size={isMobile ? 8 : 10} color={medstownColors.error} />
                  )}
                  <Typography
                    variant="caption"
                    fontWeight={600}
                    sx={{
                      fontSize: isMobile ? "0.6rem" : "0.65rem",
                      color: isCredit
                        ? medstownColors.success
                        : medstownColors.error,
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {isCredit ? "+" : "-"}₹{item.amount}
                  </Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ 
                      fontSize: isMobile ? "0.55rem" : "0.6rem",
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {dayjs(item.date).format("MMM DD")}
                  </Typography>
                </Stack>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ 
                    fontSize: isMobile ? "0.55rem" : "0.6rem",
                    whiteSpace: 'nowrap'
                  }}
                >
                  {item.status}
                </Typography>
              </Paper>
            ))
          )}
          {history.length > (isMobile ? 2 : 3) && (
            <Typography
              variant="caption"
              color="primary.main"
              sx={{ fontSize: isMobile ? "0.55rem" : "0.6rem" }}
            >
              +{history.length - (isMobile ? 2 : 3)} more
            </Typography>
          )}
        </Stack>
      </Box>
    );
  };

  // Responsive table columns with minimum widths for horizontal scroll
  const tableColumns = [
    {
      field: "delivery_name",
      headerName: "Partner Details",
      minWidth: isMobile ? 140 : 180, // Set minimum width
      flex: isMobile ? 0 : 1, // Remove flex on mobile for fixed width
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar
            sx={{
              backgroundColor: alpha(medstownColors.primary, 0.1),
              color: medstownColors.primary,
              width: isMobile ? 20 : 24,
              height: isMobile ? 20 : 24,
            }}
          >
            <MdPerson size={isMobile ? 12 : 14} />
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="caption"
              fontWeight={600}
              sx={{ 
                fontSize: isMobile ? "0.7rem" : "0.75rem",
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: isMobile ? 100 : 140
              }}
            >
              {params.value || "Unknown Partner"}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <MdPhone size={isMobile ? 8 : 10} color={theme.palette.text.secondary} />
              <Typography
                variant="caption"
                sx={{
                  fontFamily: "monospace",
                  fontSize: isMobile ? "0.6rem" : "0.65rem",
                  color: "text.secondary",
                  whiteSpace: 'nowrap'
                }}
              >
                {params.row.phone}
              </Typography>
            </Stack>
          </Box>
        </Stack>
      ),
    },
    {
      field: "balance",
      headerName: "Balance",
      minWidth: isMobile ? 80 : 100,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <Typography
          variant="caption"
          fontWeight={700}
          sx={{
            fontSize: isMobile ? "0.7rem" : "0.8rem",
            color: medstownColors.success,
            whiteSpace: 'nowrap'
          }}
        >
          ₹{params.value?.toLocaleString() || 0}
        </Typography>
      ),
    },
    {
      field: "creditHistory",
      headerName: "Credit History",
      minWidth: isMobile ? 120 : 150,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <HistoryList history={params.value || []} type="credit" />
      ),
    },
    {
      field: "debitHistory",
      headerName: "Debit History",
      minWidth: isMobile ? 120 : 150,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <HistoryList history={params.value || []} type="debit" />
      ),
    },
    {
      field: "debitTotal",
      headerName: "Total Debit",
      minWidth: isMobile ? 90 : 120,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <Typography
          variant="caption"
          fontWeight={600}
          sx={{
            fontSize: isMobile ? "0.7rem" : "0.75rem",
            color: medstownColors.error,
            whiteSpace: 'nowrap'
          }}
        >
          ₹{params.value?.toLocaleString() || 0}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: isMobile ? 100 : 120,
      flex: isMobile ? 0 : 1,
      renderCell: (params) => (
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Accept Request">
            <Button
              size="small"
              onClick={() => handleAction(params.row.id, "accept")}
              sx={{
                minWidth: isMobile ? 24 : 28,
                width: isMobile ? 24 : 28,
                height: isMobile ? 20 : 24,
                backgroundColor: alpha(medstownColors.success, 0.1),
                color: medstownColors.success,
                border: `1px solid ${alpha(medstownColors.success, 0.2)}`,
                "&:hover": {
                  backgroundColor: alpha(medstownColors.success, 0.2),
                  transform: isMobile ? "none" : "scale(1.05)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <MdCheck size={isMobile ? 12 : 14} />
            </Button>
          </Tooltip>

          <Tooltip title="Hold Request">
            <Button
              size="small"
              onClick={() => handleAction(params.row.id, "hold")}
              sx={{
                minWidth: isMobile ? 24 : 28,
                width: isMobile ? 24 : 28,
                height: isMobile ? 20 : 24,
                backgroundColor: alpha(medstownColors.error, 0.1),
                color: medstownColors.error,
                border: `1px solid ${alpha(medstownColors.error, 0.2)}`,
                "&:hover": {
                  backgroundColor: alpha(medstownColors.error, 0.2),
                  transform: isMobile ? "none" : "scale(1.05)",
                },
                transition: "all 0.2s ease",
              }}
            >
              <MdPause size={isMobile ? 12 : 14} />
            </Button>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 1, px: isMobile ? 1 : 3 }}>
        <Card sx={{ borderRadius: 2, overflow: "hidden" }}>
          <Box sx={{ p: isMobile ? 1 : 1.5 }}>
            <Skeleton
              variant="rectangular"
              height={isMobile ? 32 : 40}
              sx={{ borderRadius: 1.5, mb: 1 }}
            />
          </Box>
          <Stack spacing={1} sx={{ p: isMobile ? 1 : 1.5 }}>
            {Array.from(new Array(isMobile ? 3 : 6)).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                height={isMobile ? 40 : 45}
                sx={{ borderRadius: 1 }}
              />
            ))}
          </Stack>
        </Card>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 1, px: isMobile ? 1 : 3 }}>
      {/* Responsive Compact Header */}
      <Paper
        elevation={0}
        sx={{
          p: isMobile ? 0.75 : 1.5,
          mb: 1.5,
          borderRadius: 2,
          background: `linear-gradient(135deg, ${medstownColors.primary}, ${medstownColors.secondary})`,
          color: "white",
          position: "relative",
          overflow: "hidden",
          minHeight: isMobile ? 48 : 'auto',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={isMobile ? 1 : 2}
          sx={{ position: "relative", zIndex: 1 }}
        >
          <Stack direction="row" alignItems="center" spacing={isMobile ? 0.75 : 2}>
            <Avatar
              sx={{
                backgroundColor: alpha("#ffffff", 0.2),
                color: "white",
                width: isMobile ? 24 : 36,
                height: isMobile ? 24 : 36,
              }}
            >
              <MdLocalShipping size={isMobile ? 14 : 20} />
            </Avatar>

            <Box>
              <Typography 
                variant={isMobile ? "body2" : "h6"} 
                fontWeight={700} 
                sx={{ 
                  mb: 0,
                  fontSize: isMobile ? '0.875rem' : '1.25rem',
                  lineHeight: isMobile ? 1.2 : 1.4
                }}
              >
                {isMobile ? "Delivery Payouts" : "Delivery Partner Payouts"}
              </Typography>
              {!isSmallMobile && (
                <Typography 
                  variant="caption" 
                  sx={{ 
                    opacity: 0.9,
                    fontSize: isMobile ? "0.65rem" : "0.8rem",
                    lineHeight: 1.1
                  }}
                >
                  {isMobile ? "Manage payouts" : "Manage delivery partner payout requests"}
                </Typography>
              )}
            </Box>
          </Stack>

          <Box textAlign="right">
            <Typography 
              variant="caption" 
              sx={{ 
                opacity: 0.8,
                fontSize: isMobile ? "0.65rem" : "0.8rem",
                display: 'block',
                lineHeight: 1
              }}
            >
              {isMobile ? "Total" : "Total Partners"}
            </Typography>
            <Typography 
              variant={isMobile ? "body1" : "h6"} 
              fontWeight={700}
              sx={{ 
                fontSize: isMobile ? '0.9rem' : '1.25rem',
                lineHeight: 1
              }}
            >
              {filteredRows.length}
            </Typography>
          </Box>
        </Stack>
      </Paper>

      {/* Error Alert */}
      {error && (
        <Alert
          severity="error"
          sx={{ mb: 1.5, borderRadius: 1.5, p: 1 }}
          icon={<MdError size={16} />}
          action={
            <IconButton size="small" onClick={() => setError(null)}>
              <MdClear size={14} />
            </IconButton>
          }
        >
          <Typography variant="caption">{error}</Typography>
        </Alert>
      )}

      {/* Responsive Table Card with Horizontal Scroll */}
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          border: `1px solid ${alpha(medstownColors.primary, 0.08)}`,
          overflow: "hidden",
        }}
      >
        {/* Search Header */}
        <Box sx={{ p: isMobile ? 1 : 1.5, pb: 1 }}>
          <Stack
            direction={isMobile ? "column" : "row"}
            justifyContent="space-between"
            alignItems={isMobile ? "stretch" : "center"}
            spacing={isMobile ? 1 : 2}
          >
            <Box>
              <Typography variant="body2" fontWeight={600} sx={{ mb: 0.2 }}>
                Payout Requests
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {filteredRows.length} delivery partners
              </Typography>
            </Box>

            {/* Responsive Search */}
            <TextField
              variant="outlined"
              size="small"
              placeholder={isMobile ? "Search..." : "Search partners..."}
              value={searchText}
              onChange={handleSearchTextChange}
              fullWidth={isMobile}
              sx={{
                width: isMobile ? "100%" : 280,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: alpha(theme.palette.background.paper, 0.8),
                  borderRadius: 2,
                  fontSize: isMobile ? "0.75rem" : "0.8rem",
                  "& fieldset": {
                    borderColor: alpha(medstownColors.primary, 0.2),
                  },
                  "&:hover fieldset": {
                    borderColor: alpha(medstownColors.primary, 0.4),
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: medstownColors.primary,
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    {searchLoading ? (
                      <LinearProgress
                        sx={{ width: 16, height: 2, borderRadius: 1 }}
                      />
                    ) : (
                      <MdSearch size={16} color={medstownColors.primary} />
                    )}
                  </InputAdornment>
                ),
                endAdornment: searchText && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={clearSearch}
                      sx={{
                        color: theme.palette.text.secondary,
                        width: 20,
                        height: 20,
                      }}
                    >
                      <MdClear size={14} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Stack>
        </Box>

        {/* Horizontal Scrollable Table */}
        <Box sx={{ 
          height: isMobile ? 400 : 550, 
          px: isMobile ? 0.5 : 1.5, 
          pb: isMobile ? 0.5 : 1.5,
          // Enable horizontal scroll on all screen sizes
          overflowX: 'auto',
          width: '100%'
        }}>
          <DataGrid
            rows={filteredRows}
            columns={tableColumns}
            pageSize={isMobile ? 6 : 8}
            rowsPerPageOptions={[5, 6, 8, 15]}
            disableSelectionOnClick
            disableColumnMenu
            getRowId={(row) => row.id}
            sx={{
              border: "none",
              // Set minimum width for horizontal scroll
              minWidth: isMobile ? 650 : 800,
              width: '100%',
              "& .MuiDataGrid-main": {
                borderRadius: 1.5,
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: alpha(medstownColors.primary, 0.06),
                borderRadius: "6px 6px 0 0",
                minHeight: `${isMobile ? 32 : 36}px !important`,
                "& .MuiDataGrid-columnHeader": {
                  fontWeight: 700,
                  color: medstownColors.primary,
                  fontSize: isMobile ? "0.65rem" : "0.7rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                },
              },
              "& .MuiDataGrid-row": {
                minHeight: `${isMobile ? 50 : 60}px !important`,
                borderBottom: `1px solid ${alpha(medstownColors.primary, 0.1)}`,
                "&:hover": {
                  backgroundColor: alpha(medstownColors.primary, 0.03),
                  transform: isMobile ? "none" : "translateY(-1px)",
                },
                transition: "all 0.2s ease",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
                fontSize: isMobile ? "0.7rem" : "0.75rem",
                padding: isMobile ? "6px 8px" : "8px 12px",
              },
              // Ensure horizontal scroll works properly
              "& .MuiDataGrid-virtualScroller": {
                minWidth: '100%',
              },
            }}
          />
        </Box>
      </Card>
    </Container>
  );
};

export default DeliveryPayoutReq;
